export default __webpack_public_path__ + "static/goosby-a30bf6c94862f2cba3e695b5a83e9372.jpg";